import { render, staticRenderFns } from "./ProductFarmDetailCard.vue?vue&type=template&id=f3136d5c&scoped=true&"
import script from "./ProductFarmDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductFarmDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductFarmDetailCard.vue?vue&type=style&index=0&id=f3136d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3136d5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
